export default "__VITE_PUBLIC_ASSET__9c12238a__"